/** Route vers l'analyse titre (Stock Dashboard API — TickerAnalysis). */

export const TICKER_RETURN_ORIGINS = {
  marketflow: {
    path: "/marketflow",
    labelFr: "← Retour au Flux de Marché",
    labelEn: "← Back to Market Flow",
  },
  leaders: {
    path: "/leaders",
    labelFr: "← Retour aux Leaders de Marché",
    labelEn: "← Back to Market Leaders",
  },
  capital: {
    path: "/capital",
    labelFr: "← Retour à Capital",
    labelEn: "← Back to Capital",
  },
  screener: {
    path: "/capital/screener",
    labelFr: "← Retour au Screener",
    labelEn: "← Back to Screener",
  },
  strategies: {
    path: "/capital/strategies",
    labelFr: "← Retour aux Stratégies",
    labelEn: "← Back to Strategies",
  },
};

export function getStockDashboardPath(symbol) {
  const sym = String(symbol || "").trim();
  if (!sym) return null;
  return `/marketflow/ticker/${encodeURIComponent(sym)}`;
}

/** Libellé + chemin du bouton retour sur TickerAnalysis selon la page d'origine. */
export function resolveTickerBackNavigation(location, language = "fr") {
  const state = location?.state || {};
  const lang = language === "en" ? "en" : "fr";

  if (state.returnPath) {
    return {
      path: state.returnPath,
      label:
        state.returnLabel ||
        (lang === "en" ? "← Back" : "← Retour"),
      useHistory: false,
    };
  }

  const origin = state.from && TICKER_RETURN_ORIGINS[state.from];
  if (origin) {
    return {
      path: origin.path,
      label: lang === "en" ? origin.labelEn : origin.labelFr,
      useHistory: false,
    };
  }

  if (state.from === "nav") {
    return {
      path: null,
      label: lang === "en" ? "← Back" : "← Retour",
      useHistory: true,
    };
  }

  if (typeof window !== "undefined" && window.history.length > 1) {
    return {
      path: null,
      label: lang === "en" ? "← Back" : "← Retour",
      useHistory: true,
    };
  }

  const fallback = TICKER_RETURN_ORIGINS.marketflow;
  return {
    path: fallback.path,
    label: lang === "en" ? fallback.labelEn : fallback.labelFr,
    useHistory: false,
  };
}

export function goBackFromTicker(navigate, back) {
  if (!navigate || !back) return;
  if (back.useHistory) navigate(-1);
  else if (back.path) navigate(back.path);
}

export function navigateToStockDashboard(navigate, symbol, from) {
  const path = getStockDashboardPath(symbol);
  if (!path || !navigate) return;
  navigate(path, from ? { state: { from } } : undefined);
}

export const TICKER_LINK_STYLE = {
  background: "none",
  border: "none",
  padding: 0,
  margin: 0,
  font: "inherit",
  cursor: "pointer",
  color: "#b59a5b",
  fontFamily: "'IBM Plex Mono',monospace",
  fontWeight: 800,
  textDecoration: "underline",
  textUnderlineOffset: 2,
};

export const TICKER_ASSET_DISPLAY_STYLE = {
  fontWeight: 950,
  color: "#b59a5b",
  textDecoration: "underline",
  textUnderlineOffset: 2,
  fontFamily: "'IBM Plex Mono',monospace",
};
